export default "__VITE_ASSET__5ca7e72f__"